import { ISeatStateData, UserInfoData, IRoomInfoData } from "../../../table/module/poker_table/poker_table_data_interface";
import { Q2Game } from "../../net/proto/q2_game";
const { ccclass, property } = cc._decorator;


export class Q2RoomInfo implements IRoomInfoData{
    roomId: number
    ruleTable: any
    playerCount: number
    maxPlayerCount: number
    roundCount: number
    curRoundNum: number
    mySeatInfo: ISeatStateData
    seatInfoList: ISeatStateData[]
    serverNowTimestamp: number
    timeOffset: number
    isGoldTable?: boolean

    state: number
    stateExpiredTime: number
    stateDuration: number
    currentSeat: number
    isRoundStarted: boolean
    pokerHeapCount: number
    commonCards: number[]
    firstCommonCard: number
    firstSeatId: number
    opDir: number
}

export class Q2SeatInfo implements ISeatStateData{
    userInfo?: UserInfoData
    playerId: number = 0
    localPos: number = 0
    remotePos: number = 0
    isReady: boolean = false
    isOffLine: boolean = false
    isTmpLeave: boolean = false
    score: number = 0
    isOwner: boolean

    isBanker: boolean = false
    coinBalance: number = 0
    cards: number[] = []    
    scoreBalance: number = 0

    showQ2: boolean = false
    isPlaying: boolean = false
    canShowQ2: boolean = false
    completeInfo: Q2Game.ICompleteInfo = null
    finishedList: Q2Game.ICardPattern[] = []
    raisableList: Q2Game.ICardPattern[] = []
    storableList: Q2Game.ICardPattern[] = []
    attachableList: Q2Game.ICardPattern[] = []
    originalCardsMap: any = {}
    
    
    reset(){
        this.playerId = 0
        this.userInfo = null
        this.isReady = false
        this.isOffLine = false
        this.isTmpLeave = false
        this.score = 0

        this.isBanker = false
        this.coinBalance = 0
        this.cards = []
        this.scoreBalance = 0
        this.showQ2 = false
        this.canShowQ2 = false
        this.completeInfo = null
        this.finishedList = []
        this.raisableList = []
        this.storableList = []
        this.attachableList = []
    }

    constructor(playerId: number){
        this.playerId = playerId        
    }
}
